import React, { useEffect, useState } from "react";
import { fetchStaticData } from "../../services/tweetService";
import { useDispatch } from "react-redux";

const Path = () => {
  const dispatch = useDispatch();
  const [path, setPath] = useState("");
  useEffect(() => {
    fetchStaticData("topic-path").then((data) => setPath(data));
  }, [dispatch]);
  return (
    <div className="notificationspage two-flex-col-container">
      <div className="col1 npc-1">
        {path && <p style={{ margin: "1rem", color: "#fff" }}>{path?.content}</p>}
      </div>
    </div>
  );
};

export default Path;
